




export const treeSelectedHeliocleanSitesActions = {
    setTreeSelectedHeliocleanSitesFleet({ commit }, payload) {
        commit('SET_TREE_SELECTED_HELIOCLEAN_SITES_FLEET', payload);
      }

};
